import { render, staticRenderFns } from "./VueTour.vue?vue&type=template&id=8f308d2a"
import script from "./VueTour.vue?vue&type=script&lang=js"
export * from "./VueTour.vue?vue&type=script&lang=js"
import style0 from "./VueTour.vue?vue&type=style&index=0&id=8f308d2a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports